import moment from 'moment'
import 'moment/locale/nb'

moment.updateLocale('nb', {
  calendar : {
    sameDay: '[I dag]',
    nextDay: '[I morgen]',
    nextWeek: 'dddd',
    lastDay: '[I går]',
    lastWeek: '[Forrige] dddd',
    sameElse: 'L',
  }
})

export default moment
